// Instrument palette — a switcher of instrument chips plus the mic as a
// first-class entry (docs/07 §7.5). Selecting one sets the active source for
// play + the next recording.

export interface PaletteItem {
  id: string;
  name: string;
  color: string;
}

export interface PaletteHandlers {
  onSelect(id: string): void;
}

export interface Palette {
  element: HTMLElement;
  setActive(id: string): void;
}

export function createPalette(
  handlers: PaletteHandlers,
  items: readonly PaletteItem[],
  activeId: string,
): Palette {
  const el = document.createElement("div");
  el.className = "palette";

  const chips = new Map<string, HTMLButtonElement>();
  for (const item of items) {
    const chip = document.createElement("button");
    chip.type = "button";
    chip.className = "chip-inst";
    chip.style.setProperty("--inst-color", item.color);

    const swatch = document.createElement("span");
    swatch.className = "chip-inst__swatch";
    const name = document.createElement("span");
    name.className = "chip-inst__name";
    name.textContent = item.name;
    chip.append(swatch, name);

    chip.setAttribute("aria-pressed", String(item.id === activeId));
    if (item.id === activeId) chip.classList.add("is-active");
    chip.addEventListener("click", () => handlers.onSelect(item.id));
    chips.set(item.id, chip);
    el.append(chip);
  }

  return {
    element: el,
    setActive(id) {
      for (const [chipId, chip] of chips) {
        const active = chipId === id;
        chip.classList.toggle("is-active", active);
        chip.setAttribute("aria-pressed", String(active));
      }
    },
  };
}
